var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwacheon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3058 913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0055A8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0,
    width: 291,
    height: 911
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2767,
    y: 2,
    width: 291,
    height: 911
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654,
    y: 4,
    width: 1755,
    height: 306
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 605,
    width: 1753,
    height: 306
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwacheon);
export default __webpack_public_path__ + "static/media/hwacheon.fd47b0104a26acbcd719593d0fb4f9d3.svg";
export { ForwardRef as ReactComponent };